import {createSvgIcon} from "@mui/material";

export const RutubeIcon = createSvgIcon(
    <path d="M12.7593 10.7204C14.0623 9.65857 14.8985 8.206 14.8985 6.3827V5.58951C14.8985 2.38765 12.3292 0.0352314 9.1609 0.0352314L0.100098 0L0.105538 17.9657L4.38522 18V11.9021H8.78394L11.6515 18H16.6601L12.7593 10.7204ZM10.5254 6.16484C10.5254 7.43964 9.5017 8.16334 8.23962 8.16334H4.38522V3.84895H8.23962C9.5017 3.84895 10.5254 4.7446 10.5254 6.01972V6.16484Z"/>,
    'Rutube'
);